<app-bolt-output [calcOutput]="calcOutput"></app-bolt-output>

<app-select-tool [calcOutput]="calcOutput" [selectedTool]="selectedTool"
    *ngIf="router.url == '/idms/plantmanager'"></app-select-tool>

<app-pump-output [calcOutput]="calcOutput" [selectedTool]="selectedTool"
    [displayIDMSSettings]="displayIDMSSettings"></app-pump-output>

<app-standard-output [calcOutput]="calcOutput" (showAdvOptPanel)="showAdvancedOutputpanel()"></app-standard-output>